import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_management_user" }];

const RoleManagementListing = Loadable({
  loader: () => import("container/management/role"),
  loading() {
    return <Loader />;
  }
});
const RoleManagementPermission = Loadable({
  loader: () => import("container/management/user/rolesAndPermission/addPermission"),
  loading() {
    return <Loader />;
  }
});
const RolesAndPermissionsListing = Loadable({
  loader: () => import("container/management/user/rolesAndPermission"),
  loading() {
    return <Loader />;
  }
});
const AddUserManagement = Loadable({
  loader: () => import("container/management/user/addUser"),
  loading() {
    return <Loader />;
  }
});
const UserManagementListing = Loadable({
  loader: () => import("container/management/user"),
  loading() {
    return <Loader />;
  }
});

export const rolesAndPermissionRoutes: IRoute[] = [
  {
    path: "/management/user/roles",
    element: <RolesAndPermissionsListing />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "menu_sidebar_management_user_roles", link: "/management/user/roles" }]
    }
  },
  {
    path: "/management/user/roles/add-permission",
    element: <RoleManagementPermission />,
    handle: {
      crumbs: [
        ...parentBreadCrumbs,
        { title: "menu_sidebar_management_user_roles", link: "/management/user/roles" },
        { title: "menu_sidebar_management_add_permission" }
      ]
    }
  },
  {
    path: "/management/role",
    element: <RoleManagementListing />,
    handle: {
      crumbs: [
        ...parentBreadCrumbs,
        { title: "menu_sidebar_management_user_roles", link: "/management/user/roles" },
        { title: "menu_sidebar_management_rules" }
      ]
    }
  },
  {
    path: "/management/user/add-user",
    element: <AddUserManagement />,
    handle: {
      crumbs: [
        ...parentBreadCrumbs,
        { title: "menu_sidebar_management_user", link: "/management/user" },
        { title: "menu_sidebar_management_user_tbuser" }
      ]
    }
  },
  {
    path: "/management/user",
    element: <UserManagementListing />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "menu_sidebar_management_user" }]
    }
  }
];
